<template>
  <v-container id="homecard" fill-height style="align-items: start !important;">
    <v-row>
      <v-col cols="12" align="right">
        <v-stepper v-model="step" vertical>
          <v-stepper-step :complete="step > 1" step="1" color="warning">
            Seleccionar afiliado
            <small>Deberá ingresar el DNI del afiliado</small>
          </v-stepper-step>

          <v-stepper-content step="1">
            <v-autocomplete
              v-model="afiliado"
              :items="itemsAfiliado"
              :loading="isLoadingAfiliado"
              :search-input.sync="searchAfiliado"
              color="primary"
              hide-no-data
              hide-selected
              chips
              :item-text="textAfiliado"
              label="Afiliado"
              placeholder="Ingrese DNI del afiliado"
              prepend-icon="mdi-database-search"
              return-object
              clearable
            ></v-autocomplete>
            <v-btn color="secondary" @click="step++">Continuar</v-btn>
          </v-stepper-content>

          <v-stepper-step :complete="step > 2" step="2" color="warning">
            Describir resumen de historia clínica
            <small>Deberá adjuntar informes de estudios</small>
          </v-stepper-step>

          <v-stepper-content step="2">
            <v-textarea
              v-model="historiaClinica"
              filled
              color="primary"
              rows="3"
            ></v-textarea>
            <v-btn text @click="step--">Volver</v-btn>
            <v-btn color="secondary" @click="step++">Continuar</v-btn>
          </v-stepper-content>

          <v-stepper-step :complete="step > 3" step="3" color="warning">
            Seleccionar diagnosticos
            <small>Deberá indicar el diagnóstico primario y secondario</small>
          </v-stepper-step>

          <v-stepper-content step="3">
            <v-autocomplete
              v-model="cie10Principal"
              :items="itemsCie10Principal"
              :loading="isLoadingCie10Principal"
              :search-input.sync="searchCie10Principal"
              color="primary"
              hide-no-data
              hide-selected
              cache-items
              chips
              :item-text="textAfiliado"
              label="Diagnóstico principal"
              placeholder="Buscar en CIE10"
              prepend-icon="mdi-database-search"
              return-object
              clearable
            ></v-autocomplete>
            <v-autocomplete
              v-model="cie10Secundario"
              :items="itemsCie10Secundario"
              :loading="isLoadingCie10Secundario"
              :search-input.sync="searchCie10Secundario"
              color="primary"
              hide-no-data
              hide-selected
              cache-items
              chips
              :item-text="textAfiliado"
              label="Diagnóstico secundario"
              placeholder="Buscar en CIE10"
              prepend-icon="mdi-database-search"
              return-object
              clearable
            ></v-autocomplete>

            <v-btn text @click="step--">Volver</v-btn>
            <v-btn color="secondary" @click="step++">Continuar</v-btn>
          </v-stepper-content>

          <v-stepper-step step="4" color="warning">
            Cargar medicamentos
            <small>Utilice el botón para agregar nuevos medicamentos</small>
          </v-stepper-step>

          <v-stepper-content step="4">
            <v-container justify="center">
              <v-badge
                bordered
                color="error"
                content="0"
                overlap
              >
                <v-btn @click="dialogMedicamento = true">
                  <v-icon left>mdi-plus-circle</v-icon>
                  Agregar medicamento
                </v-btn>
              </v-badge>
            </v-container>
            <v-btn text @click="step--">Volver</v-btn>
            <v-btn color="secondary" @click="step++">Continuar</v-btn>
          </v-stepper-content>

          <v-stepper-step step="5" color="warning">
            Definir el tiempo de tratamiento estimado
            <small>Deberá indicar duración y tratamientos previos</small>
          </v-stepper-step>

          <v-stepper-content step="5">
            <v-textarea
              filled
              color="primary"
              placeholder="Tratamientos previos"
              rows="2"
            ></v-textarea>
            <v-layout>
            <v-radio-group row ma-0 pa-0>
              <span>Duracíon (meses): </span> <v-spacer></v-spacer>
              <v-radio label="2" small value="dosMeses"></v-radio>
              <v-radio label="4" value="cuatroMeses"></v-radio>
              <v-radio label="6" value="seisMeses"></v-radio>
            </v-radio-group>
            </v-layout>
            <v-btn text @click="step--">Volver</v-btn>
            <v-btn color="secondary" @click="step = 1">Finalizar</v-btn>
          </v-stepper-content>

        </v-stepper>

        <v-dialog v-model="dialogMedicamento">
          <v-container>
            <v-row>
              <v-col align="right">
              <v-stepper v-model="stepMedicamento" vertical>
                <v-stepper-step :complete="step > 1" step="1" color="secondary">
                  Nombre del medicamento
                  <small>Deberá ingresar el nombre genérico y comercial</small>
                </v-stepper-step>

                <v-stepper-content step="1">
                  <v-autocomplete
                    color="primary"
                    hide-no-data
                    hide-selected
                    chips
                    label="Nombre genérico"
                    placeholder="Ingrese un producto"
                    prepend-icon="mdi-database-search"
                    return-object
                    clearable
                  ></v-autocomplete>
                  <v-autocomplete
                    color="primary"
                    hide-no-data
                    hide-selected
                    chips
                    label="Nombre comercial sugerido"
                    placeholder="Ingrese un producto"
                    prepend-icon="mdi-database-search"
                    return-object
                    clearable
                  ></v-autocomplete>
                  <v-btn color="secondary" @click="stepMedicamento++">Continuar</v-btn>
                </v-stepper-content>

                <v-stepper-step :complete="stepMedicamento > 2" step="2" color="secondary">
                  Definir forma, potencia y dosis
                  <small>Deberá especificar la forma, potencia y dosis</small>
                </v-stepper-step>

                <v-stepper-content step="2">
                  <v-text-field
                    label="Forma farmacéutica"
                  ></v-text-field>
                  <v-text-field
                    label="Potencia/Concentración"
                  ></v-text-field>
                  <v-text-field
                    label="Dosis diaria x kg de peso"
                  ></v-text-field>
                  <v-btn text @click="stepMedicamento--">Volver</v-btn>
                  <v-btn color="secondary" @click="step++">Agregar</v-btn>
                </v-stepper-content>
              </v-stepper>
              </v-col>
            </v-row>
          </v-container>
        </v-dialog>
      </v-col>
    </v-row>
    <v-speed-dial
      v-model="fab"
      :bottom="true" :right="true" :top="false" :left="false"
      direction="top"
      transition="slide-x-reverse-transition"
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          color="warning"
          fab
        >
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            small
            color="warning"
            v-bind="attrs"
            v-on="on"
            @click.prevent="$router.push('/home')"
          >
            <v-icon>mdi-home</v-icon>
          </v-btn>
        </template>
        <span>Inicio</span>
      </v-tooltip>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            small
            color="warning"
            v-bind="attrs"
            v-on="on"
            @click.prevent="$router.push('/prescripciones')"
          >
            <v-icon>mdi-playlist-check</v-icon>
          </v-btn>
        </template>
        <span>Ver prescripciones</span>
      </v-tooltip>
    </v-speed-dial>
  </v-container>
</template>

<script>
import * as firebase from "firebase";
import { mapGetters } from "vuex";

export default {
  name: 'Prescribir',

  data: () => ({
    fab: false,
    step: 1,
    stepMedicamento: 1,
    dialogMedicamento: false,
    afiliado: null,
    historiaClinica: null,
    cie10Principal: null,
    cie10Secundario: null,
    isLoadingAfiliado: false,
    isLoadingCie10Principal: false,
    isLoadingCie10Secundario: false,
    descriptionLimitAfiliado: 60,
    searchAfiliado: null,
    searchCie10Principal: null,
    searchCie10Secundario: null,
    itemsAfiliado: [],
    itemsCie10Principal: [],
    itemsCie10Secundario: [],
    dbAfiliados: [
      {dni: 28132601, nombreApellido: 'Nahuel Alejandro Ramos'},
      {dni: 28132602, nombreApellido: 'Carlos Gutierrez'},
      {dni: 28132603, nombreApellido: 'Carolina Martinez'},
      {dni: 28132604, nombreApellido: 'Georgina Lopez'},
      {dni: 28132605, nombreApellido: 'Marcela Gonzalez'},
      {dni: 28132606, nombreApellido: 'Raúl Martín Rodriguez'},
      {dni: 28132607, nombreApellido: 'Rodolfo María García'},
      {dni: 28132608, nombreApellido: 'Hector Lopez Alberdi'},
      {dni: 28132609, nombreApellido: 'Justo Jose de Urquiza'},
      {dni: 29447381, nombreApellido: 'Raúl Martín Rodriguez'},
      {dni: 29447382, nombreApellido: 'Carlos Gutierrez'},
      {dni: 29447383, nombreApellido: 'Carolina Martinez'},
      {dni: 29447384, nombreApellido: 'Georgina Lopez'},
      {dni: 29447385, nombreApellido: 'Marcela Gonzalez'},
      {dni: 29447386, nombreApellido: 'Germán Alberto Arias'},
      {dni: 28132607, nombreApellido: 'Rodolfo María García'},
      {dni: 28132608, nombreApellido: 'Hector Lopez Alberdi'},
      {dni: 28132609, nombreApellido: 'Justo Jose de Urquiza'},
    ],
    dbCie10: [
      {codigo: 'A170', descripcion: 'Meningitis tuberculosa'},
      {codigo: 'A171', descripcion: 'Tuberculoma meningeo'},
      {codigo: 'A178', descripcion: 'Otras tuberculosis del sistema nervioso'},
      {codigo: 'A179', descripcion: 'Tuberculosis del sistema nervioso, no especificada'},
      {codigo: 'A180', descripcion: 'Tuberculosis de huesos y articulaciones'},
      {codigo: 'A181', descripcion: 'Tuberculosis del aparato genitourinario'},
      {codigo: 'A182', descripcion: 'Linfadenopatia periferica tuberculosa'},
      {codigo: 'A183', descripcion: 'Tuberculosis de los intestinos, el peritoneo y los ganglios mesentericos'},
      {codigo: 'A184', descripcion: 'Tuberculosis de la piel y el tejido subcutaneo'},
      {codigo: 'A185', descripcion: 'Tuberculosis del ojo'},
      {codigo: 'B368', descripcion: 'Otras micosis superficiales especificadas'},
      {codigo: 'B369', descripcion: 'Micosis superficial, sin otra especificacion'},
      {codigo: 'B370', descripcion: 'Estomatitis candidiasica'},
      {codigo: 'B371', descripcion: 'Candidiasis pulmonar'},
      {codigo: 'B372', descripcion: 'Candidiasis de la piel y las unas'},
      {codigo: 'B373', descripcion: 'Candidiasis de la vulva y de la vagina'},
      {codigo: 'B374', descripcion: 'Candidiasis de otras localizaciones urogenitales'},
      {codigo: 'B375', descripcion: 'Meningitis debida a Candida'},
      {codigo: 'B376', descripcion: 'Endocarditis debida a Candida'},
      {codigo: 'B377', descripcion: 'Sepsis debida a Candida'},
      {codigo: 'B378', descripcion: 'Candidiasis de otros sitios'},
      {codigo: 'B379', descripcion: 'Candidiasis, no especificada'},
      {codigo: 'B380', descripcion: 'Coccidioidomicosis pulmonar aguda'},
      {codigo: 'B381', descripcion: 'Coccidioidomicosis pulmonar cronica'},
      {codigo: 'B382', descripcion: 'Coccidioidomicosis pulmonar, sin otra especificacion'},
      {codigo: 'B383', descripcion: 'Coccidioidomicosis cutanea'},
      {codigo: 'C812', descripcion: 'Linfoma de Hodgkin clasico con celularidad mixta'},
      {codigo: 'C813', descripcion: 'Linfoma de Hodgkin clasico con deplecion linfocitica'},
      {codigo: 'C814', descripcion: 'Linfoma de Hodgkin clásico rico en linfocitos'},
      {codigo: 'C817', descripcion: 'Otros tipos de linfomas de Hodgkin clásicos'},
      {codigo: 'C819', descripcion: 'Linfoma de Hodgkin, no especificado'},
      {codigo: 'C820', descripcion: 'Linfoma folicular grado I'},
      {codigo: 'C821', descripcion: 'Linfoma folicular grado II'},
      {codigo: 'C822', descripcion: 'Linfoma folicular grado III no especificado'},
      {codigo: 'C823', descripcion: 'Linfoma folicular grado IIIa'},
      {codigo: 'C824', descripcion: 'Linfoma folicular grado IIIb'},
      {codigo: 'C825', descripcion: 'Linfoma centro folicular difuso'},
      {codigo: 'C826', descripcion: 'Linfoma centro folicular cutáneo'},
      {codigo: 'C827', descripcion: 'Otros tipos especificados de linfoma folicular'},
      {codigo: 'C829', descripcion: 'Linfoma folicular, sin otra especificacion'},
      {codigo: 'C830', descripcion: 'Linfoma de celulas B pequenas'},
      {codigo: 'C831', descripcion: 'Linfoma de celulas del manto'},
      {codigo: 'C833', descripcion: 'Linfoma de celulas grandes B difuso'},
      {codigo: 'C835', descripcion: 'Linfoma linfoblastico (difuso)'},
      {codigo: 'C837', descripcion: 'Linfoma de Burkitt'},
      {codigo: 'C838', descripcion: 'Otros tipos especificados de linfoma no folicular'},
      {codigo: 'C839', descripcion: 'Linfoma no folicular (difuso), sin otra especificacion'},
      {codigo: 'C840', descripcion: 'Micosis fungoide'},
      {codigo: 'C841', descripcion: 'Enfermedad de Sezary'},
      {codigo: 'D591', descripcion: 'Otras anemias hemoliticas autoinmunes'},
      {codigo: 'D592', descripcion: 'Anemia hemolitica no autoinmune inducida por drogas'},
      {codigo: 'D593', descripcion: 'Sindrome hemolitico-uremico'},
      {codigo: 'D594', descripcion: 'Otras anemias hemoliticas no autoinmunes'},
      {codigo: 'D595', descripcion: 'Hemoglobinuria paroxistica nocturna [Marchiafava- Micheli]'},
      {codigo: 'D596', descripcion: 'Hemoglobinuria debida a hemolisis por otras causas externas'},
      {codigo: 'D598', descripcion: 'Otras anemias hemoliticas adquiridas'},
      {codigo: 'G562', descripcion: 'Lesion del nervio cubital'},
      {codigo: 'G563', descripcion: 'Lesion del nervio radial'},
      {codigo: 'G564', descripcion: 'Causalgia'},
      {codigo: 'G568', descripcion: 'Otras mononeuropatias del miembro superior'},
      {codigo: 'G569', descripcion: 'Mononeuropatia del miembro superior, sin otra especificacion'},
      {codigo: 'G570', descripcion: 'Lesion del nervio ciatico'},
      {codigo: 'G571', descripcion: 'Meralgia parestesica'},
      {codigo: 'G572', descripcion: 'Lesion del nervio crural'},
      {codigo: 'G573', descripcion: 'Lesion del nervio ciatico popliteo externo'},
      {codigo: 'G574', descripcion: 'Lesion del nervio ciatico popliteo interno'},
      {codigo: 'G575', descripcion: 'Sindrome del tunel calcaneo'},
      {codigo: 'G576', descripcion: 'Lesion del nervio plantar'},
      {codigo: 'G578', descripcion: 'Otras mononeuropatias del miembro inferior'},
    ],
  }),

  computed: {
    ...mapGetters({
      user: "user"
    }),
  },
  methods: {
    textAfiliado: item => `(${item.dni}) ${item.nombreApellido}`,
    querySelectionsAfiliado (v) {
      this.isLoadingAfiliado = true
      setTimeout(() => {
        this.itemsAfiliado = this.dbAfiliados.filter(e => {
          // const nombreMatch = (e || '').nombreApellido.toLowerCase().indexOf((v || '').toLowerCase()) > -1
          const dniMatch = (e || '').dni.toString().indexOf((v || '')) > -1
          console.log(dniMatch)
          
          return dniMatch
        })
        this.isLoadingAfiliado = false
      }, 1000)
    },
    querySelectionsCie10Principal (v) {
      this.isLoadingCie10Principal = true
      setTimeout(() => {
        this.itemsCie10 = this.dbCie10.filter(e => {
          const descripcionMatch = (e || '').descripcion.toLowerCase().indexOf((v || '').toLowerCase()) > -1
          const codigoMatch = (e || '').codigo.toString().indexOf((v || '')) > -1
          // console.log(descripcionMatch || codigoMatch)
          return (descripcionMatch || codigoMatch)
        })
        this.isLoadingCie10Principal = false
      }, 1000)
    },
    signOut () {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace({
            name: "Login"
          });
        });
    }
  },
  watch: {
    searchAfiliado (val) {
      if (!val) return
      if (val.length >= 6) {
        val && val !== this.select && this.querySelectionsAfiliado(val)
      }
    },
    searchCie10Principal (val) {
      if (!val) return
      if (val.length >= 2) {
        val && val !== this.select && this.querySelectionsCie10Principal(val)
      }
    },
    searchCie10Secundario (val) {
      if (!val) return
      if (val.length >= 2) {
        val && val !== this.select && this.querySelectionsCie10Secundario(val)
      }
    },
  },

}
</script>

<style>
#homecard .v-speed-dial {
  position: absolute;
}

#homecard .v-btn--floating {
  position: relative;
}

.v-textarea textarea {
  font-size: 0.8em;
}

.v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 0px !important;
}
</style>